import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/ims-logo.png';
import landingImage from '../assets/403.png';
import Footer from '../components/Footer';
import { Box, Button, Typography } from '@mui/material';

const Unauthorized = () => {
  const [countdown, setCountdown] = useState(2);
  const navigate = useNavigate();

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      navigate('/');
    }
  }, [countdown, navigate]);

  return (
    <Box sx={{
      height: '100vh',
      display: 'flex',
      backgroundColor: '#fff',
      flexDirection: { xs: 'column', md: 'row' },
      overflowY: 'auto'
    }}>
      {/* Image Section */}
      <Box sx={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fffcf3'
      }}>
        <Box component="img" src={landingImage} alt="403" sx={{ height: '50%' }} />
      </Box>

      {/* Content Section */}
      <Box sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 8,
        maxWidth: 500,
        margin: '0 auto'
      }}>
        <Box component="img" src={logo} alt="IMS Logo" sx={{ width: 120, mb: 4 }} />
        
        <Typography variant="h3" sx={{ mb: 2, fontWeight: 700, color: '#2D2D2D' }}>
          403 - Access Denied
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 4, color: '#6B6B6B', fontSize: '1.1rem' }}>
          You don't have permission to view this page.
        </Typography>

        <Button
          fullWidth
          variant="contained"
          sx={{
            py: 1.5,
            borderRadius: 3,
            background: 'linear-gradient(45deg, #FF7A7A 30%, rgb(255, 210, 180) 90%)',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 4px 12px rgba(255, 122, 122, 0.3)'
            }
          }}
          onClick={() => navigate('/')}
        >
          {countdown > 0 ? `Redirecting in ${countdown}s...` : 'Go Home'}
        </Button>

        <Footer sx={{ mt: 6 }} />
      </Box>
    </Box>
  );
};

export default Unauthorized;